'use client';

import type { UploadKind } from '@dobrozem/sdk';
import { createClient, UploadsService } from '@dobrozem/sdk';

export const clientSdk = createClient({
  baseUrl: process.env.NEXT_PUBLIC_CORE_URL,
  credentials: 'include',
});

clientSdk.interceptors.request.use((request) => {
  if (typeof window === 'undefined') {
    return request;
  }

  try {
    const token = localStorage.getItem('customer_token');

    if (token) {
      request.headers.set('x-customer-session', token);
    }
  } catch (e) {
    console.error('Failed to access localStorage:', e);
  }

  return request;
});

class UploadError extends Error {
  constructor(
    readonly file: File,
    response: Response,
  ) {
    super(`Виникла помикла при завантажені файлу ${file.name}, код серверу - ${response.status}`);
  }
}

export const uploadFileOne = async (file: File, kind: UploadKind) => {
  const result = await UploadsService.uploadFile({
    body: {
      file,
      kind,
    },
    client: clientSdk,
  });

  if (!result.data) throw new UploadError(file, result.response);

  return result.data.storagePath;
};

export const uploadFiles = async (files: (File | string)[], kind: UploadKind) => {
  const results: string[] = [];

  for (const file of files) {
    results.push(typeof file === 'string' ? file : await uploadFileOne(file, kind));
  }

  return results;
};
